// Legal / informational PDFs linked from the footer. Served straight from
// public/docs/ (static files, not part of the CMS-editable content), so this
// list is tied to the actual files on disk - like navLinks, it is NOT in /admin/.
export const documentLinks = [
	{ label: 'Ceník', href: '/docs/cenik_pulsefit.pdf' },
	{ label: 'Provozní řád', href: '/docs/provozni_rad_pulsefit.pdf' },
	{ label: 'Podmínky tréninku', href: '/docs/podminky_treninku_pulsefit.pdf' },
	{ label: 'Zdravotní dotazník', href: '/docs/zdravotni_dotaznik_pulsefit.pdf' },
	{ label: 'Ochrana osobních údajů (GDPR)', href: '/docs/gdpr_ochrana_osobnich_udaju.pdf' },
];
